module.exports = __webpack_public_path__ + "img/qinghua.04efbaee.jpg";